/**
 * Formattazione italiana. Il formato data è una **preferenza dell'utente**,
 * non si deduce dalla locale del browser: arriva dalle impostazioni azienda e
 * viene passato qui.
 */
export { formattaEuro, decimaleDaCentesimi, centesimiDaDecimale } from '@mastro/core/denaro';
export { formattaData, etichettaMese, oggi, meseDi, isoDaItaliano } from '@mastro/core/date';
import { formattaEuro } from '@mastro/core/denaro';

/** Importo col segno esplicito, per le colonne dove il verso conta. */
export function euroConSegno(cent: number): string {
  const s = formattaEuro(Math.abs(cent));
  return cent < 0 ? `− ${s}` : `+ ${s}`;
}

/** Migliaia arrotondate per gli assi dei grafici: `47.800` → `47,8k`. */
export function euroCompatto(cent: number): string {
  const euro = cent / 100;
  const abs = Math.abs(euro);
  if (abs >= 1_000_000) return `${(euro / 1_000_000).toLocaleString('it-IT', { maximumFractionDigits: 1 })} mln`;
  if (abs >= 1000) return `${(euro / 1000).toLocaleString('it-IT', { maximumFractionDigits: 1 })}k`;
  return euro.toLocaleString('it-IT', { maximumFractionDigits: 0 });
}

export function numero(v: number | string | null | undefined, decimali = 2): string {
  if (v === null || v === undefined || v === '') return '—';
  const n = typeof v === 'string' ? Number(v) : v;
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: decimali });
}

export function percentuale(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—';
  const n = typeof v === 'string' ? Number(v) : v;
  return `${n.toLocaleString('it-IT', { maximumFractionDigits: 2 })}%`;
}

export const ETICHETTE_STATO: Record<string, string> = {
  DA_PAGARE: 'Da incassare',
  PARZIALE: 'Parziale',
  PAGATA: 'Saldata',
  SCADUTA: 'Scaduta',
};

export function etichettaStato(stato: string, tipo?: 'ATTIVA' | 'PASSIVA'): string {
  if (stato === 'DA_PAGARE') return tipo === 'PASSIVA' ? 'Da pagare' : 'Da incassare';
  return ETICHETTE_STATO[stato] ?? stato;
}

/** Plurale italiano senza librerie: `plurale(1,'fattura','fatture')`. */
export function plurale(n: number, uno: string, molti: string): string {
  return `${n} ${n === 1 ? uno : molti}`;
}
